_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
{ Storage } = require '@trello/storage'
{ verticals } = require 'app/scripts/views/onboarding/constants'
Language = require '@trello/locale'
{
  getSavedInspirationBoards,
  isInspirationBoard,
  getInspoBoardId,
  getVertical,
  saveBoard,
  removeBoard
} = require 'app/scripts/views/onboarding/storage'

getLocale = ->
  lowerCaseLocale = Language.currentLocale.toLowerCase()
  localeCode = switch
    when lowerCaseLocale == 'zh-tw' then 'zh-hant'
    when lowerCaseLocale == 'zh-cn' then 'zh-hans'
    when lowerCaseLocale == 'zh-hant' then 'zh-hant'
    when lowerCaseLocale == 'zh-hans' then 'zh-hans'
    when lowerCaseLocale == 'pt-br' then 'pt-br'
    else lowerCaseLocale.split('-')[0]

  return localeCode

getTranslatedFile = (fileMap, locale) ->
  localeCode = getLocale()
  fileKeys = Object.keys(fileMap)
  if fileKeys.includes(localeCode)
    return fileMap[localeCode]
  return fileMap['en']

getBoardDataForVertical = (vertical) ->
  verticals[vertical].inspirationBoards[getLocale()]

copyBoardFromVertical = (modelCache, vertical) =>
  new Promise (resolve, reject) =>
    { id, name } = getBoardDataForVertical(vertical)

    initialData = {
      name: name
      idOrganization: ''
    }

    requestData = _.extend initialData, {
      creationMethod: 'assisted'
      idBoardSource: id
      keepFromSource: 'cards'
      prefs_permissionLevel: 'private'
    }

    Auth.me().boardList.create initialData, {
      modelCache: modelCache
      requestData: requestData
      success: (board) =>
        saveBoard(id, board.id)

        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # Remove other inspiration boards from local storage and close them
        for inspoBoardId, myBoardId of getSavedInspirationBoards()
          if myBoardId != board.id
            # Coffescript binding issue here. If we dont reset this, the callback
            # will use the next id in the for loop
            id = myBoardId
            ModelCache.get('Board', id)?.close(
              -> removeBoard(id),
              false
            )

        return resolve(board)
      error: (err) -> reject(err)
    }

module.exports = {
  copyBoardFromVertical
  isInspirationBoard
  getVertical
  getBoardDataForVertical
  removeBoard
  getLocale
  getTranslatedFile
  saveBoard
}
